import { DatePipe } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
/**
 * Definición de la clase RequestHeaderSettings para configurar el encabezado de la solicitud
 *
 * *Defines RequestHeaderSettings class to set headers up in the request *
 *
 * @type {class}
 */
export class RequestHeaderSettings {
  /**
   * Función para obtener los headers para la petición
   *
   * *Function that obtains the header for the request*
   *
   * @type {function}
   * @param {GATEWAY} gateway
   * @param {string} token
   * @returns {HttpHeaders} headers
   */

  static getHeaders(token?: string, isPpid = false): HttpHeaders {
    let headers: HttpHeaders;
    const datePipe = new DatePipe('es-CO');

    if (!token) {
      headers = new HttpHeaders({});
      return headers;
    }

    headers = new HttpHeaders({
      terminal_id: '127.0.0.1',
      timestamp: isPpid ? datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss') as string :
        datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss') as string,
      Authorization: 'Bearer ' + token,
    });
    return headers;
  }

}
